export default function optimizedOut() {}
